import { render, staticRenderFns } from "./UpdateMovementVat.vue?vue&type=template&id=0bc1d35a&scoped=true&"
import script from "./UpdateMovementVat.vue?vue&type=script&lang=js&"
export * from "./UpdateMovementVat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc1d35a",
  null
  
)

export default component.exports